import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
  ElementRef,
  viewChild,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-ocr-editor',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bg-white border border-slate-300 rounded p-2 shadow-lg w-96 text-sm text-slate-900">
      <div class="flex justify-between items-center mb-1">
        <span class="text-slate-600">OCR text</span>
        <span class="text-xs text-slate-400">Edit extracted text if incorrect</span>
      </div>
      <textarea
        #ta
        rows="4"
        class="w-full bg-white text-slate-900 border border-slate-300 rounded p-1 font-mono text-xs"
        [value]="initial()"
        (keydown.escape)="cancelled.emit()"
      ></textarea>
      <div class="flex gap-2 mt-2">
        <button
          data-ocr-save
          class="px-2 py-1 border border-slate-300 rounded hover:bg-slate-100"
          (click)="onSave()"
        >
          Save
        </button>
        <button
          data-ocr-cancel
          class="px-2 py-1 border border-slate-300 rounded hover:bg-slate-100"
          (click)="cancelled.emit()"
        >
          Cancel
        </button>
      </div>
    </div>
  `,
})
export class OcrEditorComponent implements AfterViewInit {
  readonly initial = input<string>('');
  readonly saved = output<string>();
  readonly cancelled = output<void>();
  readonly taRef = viewChild<ElementRef<HTMLTextAreaElement>>('ta');

  ngAfterViewInit(): void {
    queueMicrotask(() => this.taRef()?.nativeElement.focus());
  }

  onSave(): void {
    this.saved.emit(this.taRef()?.nativeElement.value ?? '');
  }
}
